import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from "@angular/forms";
import { PriceTableService } from "@core/services/price-table.service";

@Component({
    selector: "app-driveb-price-table-model-auto-complete",
    templateUrl: "./price-table-model-auto-complete.component.html",
    styleUrls: ["./price-table-model-auto-complete.component.scss"],
    standalone: false
})
export class PriceTableModelAutoCompleteComponent implements OnInit, OnChanges {
  modelControl = new UntypedFormControl("");
  searchForm = this.fb.group({
    model: this.modelControl
  });

  allModels: { id: number; model: string }[] = [];
  models: { id: number; model: string }[] = [];

  @Input() style: string;
  @Input() currentModelId: number;
  @Input() resetForm: boolean;
  @Input() required = false;

  @Output() modelSelected = new EventEmitter<{ id: number; model: string }>();

  constructor(
    private fb: UntypedFormBuilder,
    private service: PriceTableService
  ) {}

  ngOnInit(): void {
    if (this.required) {
      this.modelControl.setValidators([Validators.required]);
    }
    this.loadModels();
    this.setupFilter();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["currentModelId"] || changes["resetForm"]) {
      this.loadModels();
    }
  }

  loadModels(): void {
    this.service.getModels().subscribe((models) => {
      this.allModels = models;
      this.models = models;

      if (this.currentModelId) {
        const match = models.find(
          (m) => Number(m.id) === Number(this.currentModelId)
        );
        if (match) {
          this.modelControl.setValue(match); // Corrigido: setar o objeto
        }
      }

      if (this.resetForm === true) {
        this.resetForm = false;
        this.searchForm.patchValue({ model: "" });
      }
    });
  }

  reset(): void {
    this.searchForm.get("model")?.setValue(null);
  }

  setupFilter(): void {
    this.modelControl.valueChanges.subscribe((search: any) => {
      if (typeof search === "string") {
        const normalized = this.normalize(search);
        this.models = this.allModels.filter((m) =>
          this.normalize(m.model).includes(normalized)
        );
      } else {
        this.models = this.allModels;
      }
    });
  }

  onModelSelected(event: any, model: { id: number; model: string }): void {
    if (event.isUserInput === true) {
      this.modelSelected.emit(model);
    }
  }

  normalize(value: string): string {
    return value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  clear(): void {
    this.searchForm.reset();
    this.models = this.allModels;
  }

  setValue(value: string): void {
    this.searchForm.get("model").setValue(value);
    this.models = this.allModels;
  }

  displayFn(model: { id: number; model: string }): string {
    return model ? model.model : "";
  }
}
